import normalizeMemberRoleId from '@/lib/settings/rolePermissions/normalizeMemberRoleId.js';

const getRoleAssignmentCounts = ({ members = [] } = {}) => {
  return (Array.isArray(members) ? members : []).reduce((accumulator, member) => {
    const roleId = normalizeMemberRoleId(member);

    if (!roleId) {
      return accumulator;
    }

    accumulator[roleId] = (accumulator[roleId] || 0) + 1;
    return accumulator;
  }, {});
};

export default getRoleAssignmentCounts;
